import { mutateApi, queryApi } from "src/utils/api/ApiMethods"

export const getNotes = async ({ marinaSlug, date }) => {
  const params = date ? `?date=${date}` : ""
  const response = await queryApi(`/manage/${marinaSlug}/notes${params}`)
  return response.notes
}

export const createNote = async ({ marinaSlug, text, startDate, endDate }) => {
  return mutateApi({
    url: `/manage/${marinaSlug}/notes`,
    method: "POST",
    data: {
      text,
      start_date: startDate,
      end_date: endDate,
    },
  })
}

export const updateNote = async ({
  marinaSlug,
  noteId,
  text,
  startDate,
  endDate,
}) => {
  return mutateApi({
    url: `/manage/${marinaSlug}/notes/${noteId}`,
    method: "PUT",
    data: {
      text,
      start_date: startDate,
      end_date: endDate,
    },
  })
}

export const deleteNote = async ({ marinaSlug, noteId }) => {
  return mutateApi({
    url: `/manage/${marinaSlug}/notes/${noteId}`,
    method: "DELETE",
  })
}
